module.exports = __webpack_public_path__ + "img/mascot.d0b2ca09.png";